import PropTypes from 'prop-types';
import React from 'react';

import t from '../../../labels/labelling-utils';
import { IComponent } from '../../../typings/generic-component';
import { IClassNames, makeClassNames } from '../../../utils/styles';

import './error.scss';

export interface IError extends IComponent {}

const defaultError = t('unavailable.data');

const classNames = (): IClassNames =>
  makeClassNames({
    error: 'error',
  });

const Error: React.FC<IError> = ({ children = defaultError }) => {
  const cn = classNames();

  return <div className={cn.error}>{children}</div>;
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  Error.propTypes = {
    children: PropTypes.node,
  };
}

export default Error;
